export type MemorialStatus = 'uninstalled' | 'installed' | 'activated' | 'active';

export interface MemorialStatusInput {
  is_installed: boolean;
  claimed: boolean;
  user_id: string | null;
}

/**
 * Determine a memorial's display status from its activation/installation flags.
 *
 * Activation is true when claimed OR user_id is set. is_activated was removed
 * as part of the analytics truth-layer cleanup — it was never written to in
 * production. See docs/analytics-truth-layer-spec.md.
 */
export const getStatusKey = (memorial: MemorialStatusInput): MemorialStatus => {
  const activated = memorial.claimed || memorial.user_id !== null;
  if (activated && memorial.is_installed) return 'active';
  if (activated) return 'activated';
  if (memorial.is_installed) return 'installed';
  return 'uninstalled';
};
